/**
 * NewQuoteProjectModal — Phase 2C.M+ (2026-09-07, refacto ClientPicker).
 *
 * Modale "Nouveau devis depuis liste `/quotes`". Délègue la sélection au
 * composant partagé `ClientPicker`, puis crée un devis brouillon POST /quotes
 * avec `lead_id` seul (le backend accepte la création sans `chantier_id`
 * depuis 2C.M+ — cf. commit d2ac707).
 */
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import ClientPicker from "@/components/quote/ClientPicker";

export default function NewQuoteProjectModal({ open, onOpenChange }) {
  const navigate = useNavigate();

  const handleSelect = async (leadId) => {
    try {
      const { data } = await api.post("/quotes", {
        lead_id: leadId,
        title: "Nouveau devis",
      });
      navigate(`/quotes/${data.id}`);
    } catch (e) {
      toast.error(formatApiError(e));
      throw e;
    }
  };

  return (
    <ClientPicker
      open={open}
      onOpenChange={onOpenChange}
      title="Créer un devis pour un contact"
      description="Choisissez le contact et le projet cible. Le devis démarre en brouillon."
      confirmLabel="Créer le devis"
      submittingText="Création…"
      onSelect={handleSelect}
    />
  );
}
